import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';
import { imageFilter, imageFilterHover } from '@/components/image/imageFilter.styles';
import { imageBlurredFadeIn } from '@/components/image/imageLoadedFadeIn.styles';
import { imagePulse } from '@/components/image/imagePulse.styles';

// Import Swiper styles
import 'swiper/css';

export const Figure = styled.figure`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      gap: 1rem;
      flex-direction: column;
      margin-bottom: 1rem;
    `;
  }};
`;

export const VideoContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      min-height: 23rem;
      width: 100%;
      border-radius: ${theme.radius.sm};
      overflow: hidden;

      background: ${theme.color.dark};

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        min-height: 32rem;
      }

      > iframe {
        border: 0;
        width: 100%;
        min-height: 23rem;
        @media screen and (min-width: ${theme.breakpoint.sm}) {
          min-height: 32rem;
        }
      }
    `;
  }};
`;

export const MainImageWrapper = styled.a`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      min-height: 23rem;
      width: 100%;
      border-radius: ${theme.radius.sm};
      overflow: hidden;

      ${imageFilter};
      ${imageFilterHover};
      img {
        ${imageBlurredFadeIn};

        &.img-pending {
          opacity: 0.4;
          position: absolute;
          height: 100%;
          width: 100%;
        }
      }

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        min-height: 32rem;
      }

      // HOVER EFFECT
      &:before,
      &:after {
        position: absolute;
        width: 100%;
        height: 100%;
        bottom: 0;
        opacity: 0;
      }

      &:before {
        content: '';
        background: rgba(0, 0, 0, 0.4);
      }

      &:after {
        content: 'Ampliar Imagem';
        font-size: ${theme.typography.font_size.base};
        font-family: ${theme.typography.font_family.text};
        text-align: center;
        color: white;
        padding-top: 6rem;
        background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.5306 20.4691L16.8365 15.776C18.1971 14.1426 18.8755 12.0475 18.7307 9.92666C18.5859 7.8058 17.629 5.8224 16.0591 4.38907C14.4892 2.95575 12.4271 2.18284 10.3019 2.23114C8.17663 2.27944 6.15181 3.14523 4.64864 4.6484C3.14547 6.15157 2.27968 8.17638 2.23138 10.3016C2.18308 12.4269 2.95599 14.489 4.38932 16.0589C5.82265 17.6288 7.80604 18.5856 9.92691 18.7304C12.0478 18.8752 14.1428 18.1968 15.7762 16.8363L20.4693 21.5304C20.539 21.6 20.6218 21.6553 20.7128 21.693C20.8038 21.7307 20.9014 21.7501 21 21.7501C21.0985 21.7501 21.1961 21.7307 21.2871 21.693C21.3782 21.6553 21.4609 21.6 21.5306 21.5304C21.6003 21.4607 21.6556 21.3779 21.6933 21.2869C21.731 21.1959 21.7504 21.0983 21.7504 20.9997C21.7504 20.9012 21.731 20.8036 21.6933 20.7126C21.6556 20.6215 21.6003 20.5388 21.5306 20.4691ZM3.74997 10.4997C3.74997 9.1647 4.14585 7.85966 4.88755 6.74963C5.62925 5.63959 6.68346 4.77443 7.91686 4.26354C9.15026 3.75265 10.5075 3.61897 11.8168 3.87943C13.1262 4.13988 14.3289 4.78275 15.2729 5.72675C16.2169 6.67076 16.8598 7.87349 17.1203 9.18287C17.3807 10.4922 17.2471 11.8494 16.7362 13.0828C16.2253 14.3162 15.3601 15.3704 14.2501 16.1121C13.14 16.8538 11.835 17.2497 10.5 17.2497C8.71037 17.2477 6.99463 16.5359 5.72919 15.2705C4.46375 14.0051 3.75195 12.2893 3.74997 10.4997Z" fill="white"/> </svg>');
        background-repeat: no-repeat;
        background-position: center 0;
        background-size: 5rem;

        transition: all 100ms ease;
        transform: translateY(calc(75% - 6rem)) scale(150%);
      }

      &:hover {
        background: transparent;

        &:before,
        &:after {
          opacity: 1;
        }

        &:before {
          background: black;
        }

        &:after {
          transform: translateY(calc(50% - 6rem)) scale(100%);
        }
      }

      ${imagePulse};
    `;
  }};
`;

// FIXME: Solve the overload TS issue here
// @ts-ignore
export const SwiperContainer = styled(Swiper)`
  ${({ theme, ...props }) => {
    return css`
      width: 100%;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        width: 2rem;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgb(255, 255, 255);
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
        z-index: 1;
      }

      .swiper-wrapper {
        padding: 1px 0;
      }

      .swiper-slide {
        position: relative;
        @media screen and (min-width: ${theme.breakpoint.sm}) {
          width: 4rem !important;
          height: 4rem !important;
          margin-right: 1rem !important;
        }
      }
    `;
  }};
`;

export const ThumbLink = styled.a`
  ${({ theme, ...props }) => {
    return css`
      //
    `;
  }};
`;

export const ThumbImageWrapper = styled.div<{ active?: boolean; contentType?: 'image' | 'video' }>`
  ${({ theme, active, contentType, ...props }) => {
    return css`
      position: relative;
      width: 4rem;
      height: 4rem;
      flex-shrink: 0;
      transition: border 50ms;
      border-bottom: 0 solid transparent;

      overflow: hidden;
      ${imageFilter};
      ${imageFilterHover};

      ${active &&
      css`
        border-bottom: 2px solid ${theme.color.neutral_800};
      `};

      &,
      img {
        // Fixes mobile device touch border not collapsing
        border-radius: ${theme.radius.sm};
      }

      ${contentType === 'video' &&
      css`
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 10;
          background-image: url('data:image/svg+xml;utf8,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.4163 15.375L14.4163 11.375C14.3032 11.2996 14.1718 11.2563 14.0361 11.2498C13.9004 11.2432 13.7655 11.2736 13.6457 11.3378C13.526 11.402 13.4259 11.4975 13.3562 11.6141C13.2865 11.7308 13.2498 11.8641 13.25 12V20C13.2498 20.1359 13.2865 20.2692 13.3562 20.3859C13.4259 20.5025 13.526 20.598 13.6457 20.6622C13.7655 20.7263 13.9004 20.7568 14.0361 20.7502C14.1718 20.7437 14.3032 20.7004 14.4163 20.625L20.4163 16.625C20.5194 16.5566 20.604 16.4637 20.6625 16.3547C20.721 16.2456 20.7517 16.1238 20.7517 16C20.7517 15.8762 20.721 15.7544 20.6625 15.6453C20.604 15.5363 20.5194 15.4434 20.4163 15.375ZM14.75 18.5987V13.4012L18.6475 16L14.75 18.5987ZM29.05 8.74999C28.9415 8.32837 28.7344 7.93854 28.4458 7.61258C28.1572 7.28661 27.7954 7.03381 27.39 6.87499C23.125 5.22374 16.2837 5.24999 16 5.24999C15.7163 5.24999 8.875 5.22374 4.605 6.87499C4.20057 7.03446 3.83971 7.28754 3.55202 7.61347C3.26434 7.9394 3.05802 8.32889 2.95 8.74999C2.63125 9.98624 2.25 12.25 2.25 16C2.25 19.75 2.63125 22.0137 2.95 23.25C3.05852 23.6716 3.2656 24.0614 3.55419 24.3874C3.84278 24.7134 4.20464 24.9662 4.61 25.125C8.875 26.7762 15.715 26.75 16 26.75H16.0888C16.9525 26.75 23.3388 26.695 27.395 25.125C27.8004 24.9662 28.1622 24.7134 28.4508 24.3874C28.7394 24.0614 28.9465 23.6716 29.055 23.25C29.3738 22.0162 29.755 19.7587 29.755 16C29.755 12.2412 29.375 9.98624 29.05 8.74999ZM27.5975 22.875C27.5494 23.0671 27.4563 23.2451 27.3259 23.3942C27.1955 23.5432 27.0315 23.6592 26.8475 23.7325C22.8475 25.2737 16.0725 25.25 16 25.25C15.9275 25.25 9.16125 25.275 5.15625 23.7287C4.97224 23.6555 4.80828 23.5395 4.67788 23.3904C4.54749 23.2413 4.45438 23.0634 4.40625 22.8712C4.105 21.7225 3.75 19.5975 3.75 16C3.75 12.4025 4.105 10.2775 4.4025 9.12499C4.45064 8.93287 4.54374 8.75492 4.67413 8.60584C4.80453 8.45675 4.96849 8.34078 5.1525 8.26749C9.0075 6.78249 15.4413 6.74999 15.97 6.74999H16C16.0675 6.74999 22.8387 6.72499 26.8438 8.27124C27.0278 8.34453 27.1917 8.4605 27.3221 8.60959C27.4525 8.75868 27.5456 8.93662 27.5938 9.12874C27.8913 10.2775 28.2463 12.4025 28.2463 16.0037C28.2463 19.605 27.895 21.7225 27.5975 22.875Z" fill="black"/></svg>');
          background-position: center;
          background-repeat: no-repeat;
        }
      `}
    `;
  }};
`;
